export { default } from "../../components/page/register/sign-up";
import { getI18NLogin } from "src/services/i18n/getI18NLogin";
import { getI18NSignUpFlow } from "src/services/i18n/getI18NSignUpFlow";

export const getStaticProps = async ({ locale: l }) => {
  const locale = l || "en";

  if (process.env.NEXT_PUBLIC_NO_SIGN_UP === "true") {
    return {
      notFound: true,
    };
  }

  const [login, signUpFlow] = await Promise.all([getI18NLogin({ locale }), getI18NSignUpFlow({ locale })]);

  return {
    revalidate: isNaN(parseInt(`${process.env.NEXT_PUBLIC_I18N_REVALIDATE}`))
      ? 10
      : parseInt(`${process.env.NEXT_PUBLIC_I18N_REVALIDATE}`),
    props: {
      i18n: {
        login,
        signUpFlow,
      },
    },
  };
};
